<template>
    <v-row class="mt-10 fill-height primary">
      <v-col cols="12" class="pa-0">
        <v-row class="py-12 my-12 px-5">
          <v-col cols="12" md="12" class="pt-0" TRANSACTIONS>
            <v-row>
              <v-col cols="12" md="4" PANNELS>
              </v-col>
              <v-col cols="12" md="4" PANNELS>
                <v-card color="white" class="pa-3" :loading="loading">
                  <v-card class="text-center primary py-5 elevation-2 align-center">
                    <img v-if="site.wlogo" :src="site.wlogo" width="110" alt="">
                  </v-card>
                  <v-card-text class="text-center">
                    <v-alert type="success" v-if="!loading && verify_success" :value="true" :class="`${arabic?'arFont':'enFont'}`">
                      {{ i18n['you_are_qualified_and_added_to_newsletter_list'] }}
                    </v-alert>
                    <v-alert type="error" v-if="!loading && !verify_success" :value="true" :class="`${arabic?'arFont':'enFont'}`">
                      {{ i18n['there_is_a_problem_please_contact_support'] }}
                    </v-alert>
                    <v-btn v-if="!loading" color="success" @click="goTo('/login')" :class="`${arabic ? 'arFont' : ''}`">
                      {{ i18n['register'] }}
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" PANNELS>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>
import Search from '@/components/Search'
export default {
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      verify_success:false,
      newResource:{},
      editing:false,
      deleting:false,
    }
  },
  methods: {
    async registerToMailList(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await this.$store.dispatch('getResource', {resource:`/maillist/${this.$route.params.hash}`})
        // console.log(a)
        this.verify_success = a.success
        this.loading = false
      })
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    this.registerToMailList()
  },
}
</script>

<style>

</style>